import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import authService from '../../common/services/authService';
import {handleError} from '../../common/utils/errorHandling';
import {
  CenteredButton,
  CenteredForm,
  CenteredHeader,
  CenteredInputText,
  CenteredLayout
} from '../../layout/centered/components';
import InlineErrorMessage from '../../common/components/InlineErrorMessage';

const ForgotPassword: React.FC = () => {
  const {t} = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError('');

    await handleError(
      async () => {
        await authService.requestPasswordReset(email);
        navigate('/forgot-password-confirmation');
      },
      'Password reset request failed:',
      (err: any) => {
        const backendError = err?.response?.data?.error || err?.response?.data?.message;
        setError(backendError || t('common.pages.forgotPassword.errorFailed'));
      }
    );
  };

  return (
    <CenteredLayout sectionId="forgot-password-section">
      <CenteredHeader
        title={t('common.pages.forgotPassword.title')}
        subtitle={t('common.pages.forgotPassword.subtitle')}
      />

      <CenteredForm onSubmit={handleSubmit}>
        <CenteredInputText
          id="email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('common.pages.forgotPassword.emailPlaceholder')}
          label={t('common.pages.forgotPassword.email')}
          icon="fa fa-envelope"
          required
        />

        <InlineErrorMessage message={error}/>

        <CenteredButton
          type="submit"
          label={t('common.pages.forgotPassword.sendResetLink')}
          icon="fa fa-paper-plane"
          iconPos="left"
        />
      </CenteredForm>
    </CenteredLayout>
  );
};

export default ForgotPassword;
